var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"templates"},[_c('div',{staticClass:"buttons is-pulled-right"},[_c('b-button',{attrs:{"type":"is-primary"},on:{"click":function($event){return _vm.$router.push({
          name: 'configuration.templates.create'
        })}}},[_vm._v("\n      CREATE\n    ")])],1),_vm._v(" "),_c('base-table',{ref:"baseTable",attrs:{"service":_vm.$options.templateService,"fetch-func":"all","columns":_vm.$options.columns},scopedSlots:_vm._u([{key:"rowIsDefault",fn:function(ref){
        var row = ref.row;
return [_c('b-switch',{attrs:{"value":_vm.isSetAsDefault(row),"type":"is-info"},on:{"input":function($event){return _vm.setAsDefault(row)}}})]}},{key:"rowActions",fn:function(ref){
        var row = ref.row;
return [_c('b-button',{on:{"click":function($event){return _vm.$router.push({
            name: 'configuration.templates.edit',
            params: { id: row.id }
          })}}},[_vm._v("\n        Edit\n      ")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6eddd3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Templates/index.vue
// module id = null
// module chunks = 